/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ReasoningTraceMeta = zod
	.object({
		iteration_count: zod.number().nullable().describe('Number of iterations'),
		termination_reason: zod.string().nullable().describe('Why the agent terminated'),
		total_tool_calls: zod.number().nullable().describe('Total tool calls made')
	})
	.describe('Summary metadata for a reasoning trace');

export type ReasoningTraceMeta = zod.input<typeof ReasoningTraceMeta>;
export type ReasoningTraceMetaOutput = zod.output<typeof ReasoningTraceMeta>;
